export function getDialogConfig(options: any) {
    return Object.assign({
        width: '400px',
        panelClass: 'dialog-no-padding',
        autoFocus: false,
        closeOnNavigation: false,
        backdropClass: 'custom-backdrop'
    }, options);
}
